import { useEffect, useState } from "react";
import "../Styles/component.css";

const InputContent = ({
  setContent,
  content,
  placeholder,
  maxLength,
  readOnly = false,
}) => {
  const [content_count, setContent_count] = useState(0);

  const contentMaxLength = maxLength ?? 500;

  const handleContentChange = (e) => {
    if (readOnly) {
      return;
    }

    const value = e.target.value;
    if (value.length <= contentMaxLength) {
      setContent(value);
      setContent_count(value.length);
    }
  };

  useEffect(() => {
    setContent_count(content.length);
  }, [content]);

  return (
    <div
      className="textinputBox"
      style={{ marginTop: "14px", flexDirection: "column" }}
    >
      <textarea
        type="text"
        placeholder={placeholder ? placeholder : "상세 정보를 입력해주세요"}
        style={{ width: "700px", height: "176px", resize: "none" }}
        className="textinput"
        value={content}
        onChange={handleContentChange}
        readOnly={readOnly}
      />
      <div style={{ color: "#888888", marginLeft: "auto" }}>
        {content_count.toLocaleString("ko-KR")}/
        {contentMaxLength.toLocaleString("ko-KR")}
      </div>
    </div>
  );
};

export default InputContent;
